import getConfig from 'next/config';

import { IMaterialItem, MaterialResponse, MaterialsTopResponse, RubricsResponse } from '../interfaces/news';
import client from '../utils/client';

interface IDictionaryParams {
  type: string;
}

interface IRubricsParams {
  placement?: string;
}

interface IMaterialsParams {
  limit?: number;
  placement?: string;
  placementLimit?: number;
}

export interface INewsParams {
  Page: number;
  Limit: number;
}

export const getDictionary = async (params: IDictionaryParams): Promise<RubricsResponse> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/news/dictionary/`;
  const { data } = await client.post<RubricsResponse>(url, params);

  return data;
};

export const getRubrics = async (params?: IRubricsParams): Promise<RubricsResponse> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/news/rubrics/`;
  const { data } = await client.post<RubricsResponse>(url, params);

  return data;
};

export const getMaterials = async (params: IMaterialsParams): Promise<IMaterialItem[]> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/news/materials/`;
  const { data } = await client.post<IMaterialItem[]>(url, params);

  return data;
};

export const getMaterialsTop = async (): Promise<MaterialsTopResponse> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/news/materialsTop/`;
  const { data } = await client.post<MaterialsTopResponse>(url);

  return data;
};

export const getMaterialsHighlightsNews = async (params: INewsParams): Promise<MaterialResponse> => {
  const url = `${getConfig().publicRuntimeConfig.proxyPath}/news/materialsHighlightsNews/`;
  const { data } = await client.get<MaterialResponse>(url, { params });

  return data;
};
